import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"

import { WarehouseFilter } from "./WarehouseFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"
import { useHandleClearFilters } from "@/screens/Warehouses/hooks/useHandleClearFilters"
import { WarehouseStatus } from "@/screens/Warehouses/types"

interface SearchFilterProps {
  showFilter: boolean
  toggleFilter: () => void
}

export const WarehouseFilterDrawer: FC<SearchFilterProps> = ({ showFilter, toggleFilter }) => {
  const navigate = useNavigate({ from: "/app/admin/warehouses" })
  const { methods, onClear } = useHandleClearFilters()

  const handleFilterChange = (name: string, value: any) => {
    let searchReducer: (prev: Record<string, any>) => Record<string, any>

    if (name === "isActive") {
      let isActiveValue
      if (value === WarehouseStatus.Active) {
        isActiveValue = true
      } else if (value === WarehouseStatus.Inactive) {
        isActiveValue = false
      } else {
        isActiveValue = undefined
      }

      searchReducer = (prev) => ({
        ...prev,
        isActive: isActiveValue,
      })
    } else {
      searchReducer = (prev) => ({
        ...prev,
        [name]: value.length > 0 ? value : undefined,
      })
    }

    navigate({
      search: searchReducer,
      replace: true,
    })
  }

  return (
    <SearchFilterDrawer toggleDrawer={toggleFilter} open={showFilter} clear={onClear} testId='warehouse-filter-drawer'>
      <WarehouseFilter onFilterChange={handleFilterChange} methods={methods} />
    </SearchFilterDrawer>
  )
}
